import {useState, useEffect, useRef, RefObject} from 'react'

function useElementSize(ref: RefObject<HTMLElement | null>) {
  const [size, setSize] = useState<{width: number; height: number}>({
    width: 0,
    height: 0,
  })

  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        setSize({
          width: ref.current.offsetWidth,
          height: ref.current.offsetHeight,
        })
      }
    }

    // Initial calculation
    handleResize()

    // Event listener for window resize
    window.addEventListener('resize', handleResize)

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return size
}

export default useElementSize
